export const DateRangeMode = { Week: 'Week', Month: 'Month' } as const;

export type DateRangeMode = (typeof DateRangeMode)[keyof typeof DateRangeMode];
